module.exports = __webpack_public_path__ + "img/face_with_rolling_eyes.0845dbd2.gif";